import { request } from '@/utils'
import { validateDataType } from '@/types/business'

export const getUserInfo = async (): Promise<any> => {
  return request.get('/uc/account/info/simple');
};

export const getPicByResource = async (file: string): Promise<any> => {
  return request.get(`/api/trantor/portal/file/url?fileUrl=${file}`);
};

export const getHotAddress = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/VEGETA$query_area_floor_configuration_top5_areas',
    { params: { request: {} } }
  );
};

export const getAreas = async (): Promise<any> => {
  return request.get(
    '/crm/cdi/api/v1/areas?ctoken=cdaa0633-d61d-4561-b3ce-e43833cd24d5&areaType=PROVINCE&type=CAIXIAO'
  );
};
export const getEnterpriseInfo = async (): Promise<any> => {
  return request.get('/bcpmember/queryCurrentMember');
};

export const getEnterpriseInfoDetail = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/TB2B$MAL_CURRENT_CUSTOMER_INFO_ACTION_SERVICE',
    {
      params: {
        request: {},
      },
    }
  );
};

export const logout = async ({ id: string }): Promise<any> => {
  return request.get('/uc/logout');
};


// 获取当前账户是否是白名单
export const getCarbonConfig = async (): Promise<any> => {
  return request.post(
    '/api/trantor/service/engine/execute/TB2B$query_carbon_config',
    { 
      params: { 
        request: {
          pcpBizType: "pcpCenter",
          paramName: "MAL_DOMAIN_CONFIG"
        } 
      }
    }
  );
};

// 询价报价校验
export const validateOffer = async (params: any): Promise<validateDataType> => {
  return request.get(
    '/bcpcrm/rest/api/quotation/validate',
    { 
      params
    }
  );
};

/**
 * desc 报价券权益
 */
export const getBenefitQuotaInfo = (): Promise<any> => request.get('/bcpcrm/rest/api/member-quota/quota', {});

/**
 *  获取权益缺失接口
 */
export const getBenefitBaseInfo = (): Promise<any> => request.get('/bcpcrm/rest/api/member-quota/base', {});

/**
 * 获取白名单权益
 */
export const getBenefitWhiteInfo = (params: any): Promise<any> => request.post('/bcpcrm/rest/api/quotation/mySupplierWhiteDetail', { ...params });

/**
 * 埋点统计
 */
export const createSupplierBuryingPoint = (params: any): Promise<any> => request.post('/bcpcrm/rest/api/buryingPoint/createSupplierBuryingPoint', { ...params });

export type SupplierTrackMemberLevel =
  | "guest"
  | "supplier"
  | "ca_supplier"
  | "adv_supplier";

export type SupplierTrackEvent = {
  eventId?: string;
  eventName: "guide_expose" | "guide_click" | "guide_close";
  eventType: "EXPOSE" | "CLICK" | "CLOSE";
  eventTime?: number;
  slotId: string;
  memberLevel?: SupplierTrackMemberLevel;
  inOpenList?: boolean;
  device: "pc" | "h5" | "app";
  pageName: string;
  moduleName: string;
  elementName: string;
  closeType?: "close" | "close_today";
  properties?: Record<string, unknown>;
};

/**
 * 供应商付费引导位埋点用户等级
 */
export const getSupplierTrackMemberLevel = (
  memberQuotaBaseInfo?: any,
): SupplierTrackMemberLevel => {
  const memberTypeCode = memberQuotaBaseInfo?.memberTypeCode;
  const caMemberTypeCode = memberQuotaBaseInfo?.caMemberTypeCode;

  if (
    (memberTypeCode === undefined || memberTypeCode === null) &&
    (caMemberTypeCode === undefined || caMemberTypeCode === null)
  ) {
    return "guest";
  }

  const isPremiumPackage = memberTypeCode === "PREMIUM_PACKAGE";
  const isCaCertified = caMemberTypeCode === "FADADA_CA_CERTIFIED";

  if (isPremiumPackage && !isCaCertified) {
    return "adv_supplier";
  }

  if (!isPremiumPackage && isCaCertified) {
    return "ca_supplier";
  }

  return "supplier";
};

/**
 * 供应商付费引导位埋点
 */
export const createSupplierTrackEvent = (
  event: SupplierTrackEvent,
): Promise<any> =>
  request.post('/bcpcrm/rest/api/supplier/track/events', { events: [event] });